const KENTIK_TENANCY_ID = 'ocid1.tenancy.oc1..aaaaaaaaau7s2ul5f4egoc5ogvofp22gt6y6gps6vxco7huazjvke5lcvfrq';
const KENTIK_USER_GROUP_ID = 'ocid1.group.oc1..aaaaaaaaiqoqvp4hqfjmjftbab6q3yo3uxny57mxdko6uqyhm536wiy2zj7a';
const KENTIK_USER_GROUP_ID_OUR1 = 'ocid1.group.oc1..aaaaaaaafh42eh5euiqsnu4jqyruzeov6tkl2v5hqdlswnzcow4vhherr3bq';

module.exports = {
  KENTIK_TENANCY_ID,
  KENTIK_USER_GROUP_ID,
  KENTIK_USER_GROUP_ID_OUR1
};
